// EN
export const reservasHc = {
  // ── CheckinsList.vue ──────────────────────────────────────────────────────
  checkinsList: {
    newCheckin: "New check-in",
    manualDispatchTitle: "Manual close of the final delivery",
    manualDispatchText:
      "If one of the guests will not travel, you can manually close this process to send the welcome message, the digital keys and the document to the booking holder now.",
    sending: "Sending...",
    completeManualSend: "Complete manually and send",
    finalSendProcessed: "Final delivery already processed",
    arrivalInstructions: "Arrival instructions",
    arrivalAlreadySent: "Already sent. You can resend them to the guest now if you need to.",
    arrivalAutoInfo:
      "They are sent automatically at their scheduled time. You can bring them forward and send them now (message, access and configured files).",
    resendNow: "Resend now",
    sendNow: "Send now",

    titleEditCheckin: "Edit check-in",
    titleDeleteCheckin: "Delete check-in",

    confirmManualTitle: "Complete the delivery manually?",
    confirmManualMsg:
      "Use this action when there will be no more guests checking in and you need to send the final information to the booking holder now.",
    yesSendNow: "Yes, send now",
    cancel: "Cancel",
    manualSendFailed: "The manual delivery could not be completed.",
    sendProcessedTitle: "Delivery processed",
    finalInfoProcessed: "The final check-in information has already been processed.",
    couldNotSend: "Could not send",

    confirmResendArrivalTitle: "Resend arrival instructions?",
    confirmSendArrivalTitle: "Send arrival instructions now?",
    confirmResendArrivalMsg:
      "The arrival instructions have already been sent. Do you want to send them to the guest again now?",
    confirmSendArrivalMsg:
      "The arrival instructions (message, access and configured files) will be sent to the guest now, without waiting for the scheduled time.",
    arrivalSendFailed: "The arrival instructions could not be sent.",
    pendingDeliveryTitle: "Pending delivery",
    instructionsSentTitle: "Instructions sent",
    arrivalSentToGuest: "The arrival instructions were sent to the guest.",

    stepGuestData: "Guest details",
    stepSignature: "Signature",
    stepRegistered: "Check-in registered",

    sectionPersonal: "Personal details",
    sectionStay: "Stay",
    sectionDocument: "Document",

    nombre: "First name",
    apellido: "Last name",
    sexo: "Sex",
    select: "Select",
    male: "Male",
    female: "Female",
    preferNotToSay: "Prefer not to say",
    other: "Other",
    birthDate: "Date of birth",
    minorsTraveling: "Are minors traveling on this booking?",
    no: "No",
    yes: "Yes",
    relationshipMinor: "Relationship of the minor",
    relationshipToMinor: "Relationship to the minor",
    phone: "Phone",
    email: "Email",
    checkInDate: "Check-in date",
    checkOutDate: "Check-out date",

    nationality: "Nationality",
    cittadinanza: "Cittadinanza / Nationality",
    documentType: "Document type",
    documentNumber: "Document number",
    supportNumber: "Support number",
    docTypes: {
      passport: "Passport",
      identityDoc: "Identity Document",
      co_cc: "Citizenship ID Card",
      co_ce: "Foreigner ID Card",
      co_ppt: "Temporary Protection Permit",
      co_pep: "Special Permanence Permit",
      co_de: "Foreign Document",
    },
    relationships: {
      co: {
        PADRE: "Father",
        MADRE: "Mother",
        HIJO: "Son/Daughter",
        ABUELO: "Grandfather/Grandmother",
        HERMANO: "Brother/Sister",
        TIO: "Uncle/Aunt",
        TUTOR: "Legal guardian",
        OTRO: "Other",
      },
      es: {
        HJ: "Son/Daughter",
        AB: "Grandfather/Grandmother",
        BA: "Great-grandfather/mother",
        BN: "Great-grandchild",
        CD: "Brother/Sister-in-law",
        CY: "Spouse",
        HR: "Brother/Sister",
        NI: "Grandchild",
        OT: "Other",
        PM: "Father/Mother",
        SB: "Nephew/Niece",
        SG: "Father/Mother-in-law",
        TI: "Uncle/Aunt",
        TU: "Guardian",
        YN: "Son/Daughter-in-law",
      },
    },

    italyBannerTitle: "Data required in Italy · Alloggiati Web",
    italyBannerText:
      "The Polizia di Stato requires the state of birth, the municipality of birth and the place of document issue.",
    sectionBirthData: "Birth details",
    statoNascita: "Stato di nascita / Country of birth",
    birthStateHint: "The state of birth may differ from the nationality.",
    comuneNascita: "Municipality of birth",
    luogoRilascio: "Place of document issue",
    luogoRilascioHint: "Italian municipality or foreign State that issued the document.",
    searchCittadinanza: "Search citizenship…",
    searchStatoNascita: "Search state of birth…",
    searchComuneNascita: "Search municipality of birth…",
    searchComuneRilascio: "Municipality of issue…",
    searchStatoRilascio: "State of issue…",

    sectionSes: "SES Hospedajes data",
    countryResidence: "Country of residence",
    cityResidence: "City of residence",
    address: "Address",
    zipCode: "Postal code",
    paymentMethod: "Payment method",
    paymentDate: "Payment date",
    pay: {
      efectivo: "Cash",
      destino: "Pay at destination",
      tarjeta: "Card",
      movil: "Mobile payment",
      plataforma: "Platform",
      transferencia: "Bank transfer",
    },

    sireLegalTitle: "SIRE & TRA — Legal Notice",
    sireLegalText:
      "For establishments in Colombia, the information requested is collected in accordance with the regulations of Migración Colombia (SIRE) and the guest register (TRA).",
    sectionSire: "SIRE / TRA data",
    searchNationality: "Search nationality...",
    searchCountry: "Search country...",
    noResults: "No results",
    countryOrigin: "Country of origin",
    searchCountryOrigin: "Search country of origin...",
    cityOrigin: "City of origin",
    searchCity: "Search city...",
    searchMunicipality: "Search municipality...",
    nextDestinationCountry: "Next destination country",
    searchDestinationCountry: "Search destination country...",
    summaryOrigin: "Origin",
    summaryDestination: "Destination",

    sectionIdentity: "Identity verification",
    recommended: "recommended",
    identityActiveInfo:
      "This property has identity verification enabled. Upload photos of the guest's document.",
    documentFront: "Front of the document",
    uploadPhoto: "Upload photo",
    selfieGuest: "Guest selfie",
    altDocumentFront: "Document front",
    altMinorAuth: "Minor authorization",
    titleRemove: "Remove",

    sectionMinorDocs: "Minor documentation",
    optional: "optional",
    minorInfo: "For minors you can upload the travel authorization or the guardian's document.",
    guardianAuthDoc: "Authorization / Guardian's document",
    uploadDocument: "Upload document",

    sectionSignature: "Guest signature",
    signatureHint: "Ask the guest to sign in the box to accept the property's terms.",
    undo: "Undo",
    clear: "Clear",
    termsAccept: "The guest accepts the property's terms and conditions",

    successTitle: "Check-in registered!",
    successBefore: "The check-in for",
    successAfter: "has been saved successfully.",

    next: "Next",
    back: "Back",
    saving: "Saving...",
    saveCheckin: "Save check-in",
    close: "Close",

    vNombre: "First name is required",
    vApellido: "Last name is required",
    vSexo: "Sex is required",
    vBirthDate: "Date of birth is required",
    vPhone: "Phone is required",
    vCheckIn: "Check-in date is required",
    vCheckOut: "Check-out date is required",
    vNationality: "Nationality is required",
    vDocType: "Document type is required",
    vDocNumber: "Document number is required",
    vEmailFormat: "The email format is not valid",
    vDocSupport: "The document support number is required",
    vMinors: "Indicate whether minors are traveling on the booking",
    vRelationship: "The relationship of the accompanying minor is required",
    vCountryResidence: "Country of residence is required",
    vCityResidence: "City of residence is required",
    vAddress: "Address is required",
    vZip: "Postal code is required",
    vPaymentMethod: "Payment method is required",
    vPaymentDate: "Payment date is required",
    vCountryOrigin: "Country of origin is required",
    vNextDest: "Next destination country is required",
    vCityOrigin: "City of origin is required",
    vStatoNascita: "The state of birth (Stato di nascita) is required",
    vComuneNascita: "The municipality of birth (Comune di nascita) is required",
    vLuogoRilascio: "The place of document issue (Luogo di rilascio) is required",

    vTerms: "You must accept the terms to continue",
    vSignaturePad: "Error accessing the signature panel",
    vSignature: "The signature is required",
    saveCheckinError: "An error occurred while saving the check-in",
    saveCheckinErrorGeneric: "Error saving the check-in",
    socketCheckinDone: "<strong>{name}</strong> completed the manual check-in",
    identityPhotosError: "The check-in was saved, but the identity photos could not be uploaded",
    minorAuthError: "The check-in was saved, but the minor's authorization could not be uploaded",

    docDni: "Invalid DNI. It must have 8 digits followed by the correct control letter (e.g. 12345678Z)",
    docNie: "Invalid NIE. Format: X/Y/Z + 7 digits + control letter (e.g. X1234567Z)",
    docPassport: "Invalid passport. It must have between 6 and 20 alphanumeric characters",
    docCc: "Invalid Citizenship ID Card. It must have between 6 and 10 digits",
    docCe: "Invalid Foreigner ID Card. It must have between 6 and 12 alphanumeric characters",
    docPptPep: "Invalid {tipo}. It must have between 4 and 15 alphanumeric characters",

    zipNotFound: "Postal code not found. Check the number and try again.",
  },

  // ── PageReservation.vue ───────────────────────────────────────────────────
  pageReservation: {
    requestPendingTitle: "Booking request pending",
    requestPendingText:
      "The guest requested these dates. The calendar is not blocked until you approve.",
    approving: "Approving…",
    approve: "Approve",
    rejecting: "Rejecting…",
    reject: "Reject",
    requestRejectedTitle: "Request rejected",
    requestRejectedText: "This request was rejected by the property and can no longer be confirmed.",
    awaitingPaymentTitle: "Awaiting guest payment",
    awaitingPaymentText:
      "The calendar is temporarily blocked. If payment is not made, availability is released automatically.",
    remaining: "remaining",
    marking: "Marking...",
    markAsPaid: "Mark as paid",
    expiring: "Expiring...",
    markAsExpired: "Mark as expired",

    extensionPendingTitle: "Stay extension pending",
    extraNights: "{count} extra night(s)",
    newCheckout: "new check-out",
    awaitingGuestPayment: "awaiting the guest's payment",
    holdLeftMinutes: "{min} min left to pay",
    holdLeftSeconds: "{seg} s left to pay",
    holdExpired: "the hold expired: the nights were released",
    pendingApproval: "pending approval",
    confirming: "Confirming...",

    observation: "Note",

    pendingCharge: "pending payment",
    processing: "Processing...",

    clientRequested: "The client requested:",
    serviceFallback: "Service",
    toConsult: "on request",

    approveRequestTitle: "Approve request",
    amountToCharge: "Amount to charge",
    noCharge: "0 = no charge",
    approveHint:
      "If you have a payment gateway connected, a <strong>payment link</strong> is sent to the guest (WhatsApp + email). If not, they are told they will <strong>pay on arrival</strong>.",
    cancel: "Cancel",
    close: "Close",
    approveAndNotify: "Approve and notify",

    reservationTotal: "Booking total:",
    onRequestPaidSeparately: `"on request" items are paid separately`,
    fullPayment: "Full payment",
    noBalance: "(no balance)",
    deposit: "Deposit",
    balance: "balance",
    markPaidHint: `The chosen amount is recorded as collected. The "total" covers stay, cleaning and priced services (e.g. Uber); "on request" items have their own charge.`,
    confirm: "Confirm",

    paymentExpiredTitle: "Payment time expired",
    paymentExpiredText: "The temporary booking expired and availability was released automatically.",

    overbookingTitle: "Booking in overbooking",
    overbookingText:
      "Its dates clash with another booking for this property. The dates remain blocked on the OTAs. If you have already resolved the conflict (canceled or moved the other booking), confirm it here.",
    verifying: "Verifying...",
    confirmReservation: "Confirm booking",

    checkinInvitation: "Check-in invitation",
    copyCheckinLink: "Copy check-in link",
    editReservation: "Edit booking",

    codesAndAccess: "Codes and access",
    codesAndAccessSub: "Guest's access keys and links",
    currentAccessCodes: "Current access codes:",
    currentAccessCode: "Current access code:",
    guestDigitalAccess: "Guest digital access",
    copyOpenLink: "Copy opening link",
    copy: "Copy",
    openLink: "Open opening link",
    open: "Open",
    yacanNote: "The access for this booking is managed by <b>YACAN</b> automatically with its locks.",
    digitalKeyEkey: "Digital key (ekey)",
    openDigitalKey: "Open digital key",
    previousCodesExpired: "Previous codes (already expired):",
    sentOn: "sent on",
    generated: "generated",
    expiredOn: "expired on",

    amountAndPayment: "Amount and payment",
    amountAndPaymentSub: "Breakdown, collection status and invoicing",

    guestJourney: "Guest journey",
    eventsCount: "{count} event | {count} events",
    journeySubtitle: "Full traceability from booking to check-out",
    stagesCompleted: "stages completed",
    nextLabel: "Next:",
    // Cabecera del bloque de etapas que aún no han ocurrido; van FUERA de la cronología.
    pendingAhead: "Still to come",
    // El envío del parte a las autoridades: cada servicio lo apunta en historial_firmas.
    authoritiesTitle: "Guest register",
    authoritiesAction: "was reported to the authorities",
    authoritiesDesc: "Sent to {services}",
    viewInChat: "View in chat",

    accessCode: "Access code",
    accessCodeSub: "Edit and send the key to the guest",
    currentlyConfiguredCode: "Currently configured code",
    newCode: "New code",
    keepSameToResend: "leave it the same to resend without changes",
    placeholderCode: "E.g. ABCD1234",
    codeSavedUppercaseHint: "The code will be saved in uppercase and sent via WhatsApp and/or email.",
    sending: "Sending...",
    saveAndSendToGuest: "Save and send to guest",

    resendAccess: "Resend access",
    sendAccess: "Send access",
    resendPin: "Resend PIN",
    sendPin: "Send PIN",
    activating: "Activating...",
    resendCode: "Resend code",
    sendAccessCode: "Send access code",

    channelManager: "channel manager",
    directBooking: "direct booking",
    directTag: "Direct",
    bookingRegistered: "Booking registered",
    bookedViaOta: "booked via OTA",
    createdBooking: "created the booking",
    incomingVia: "Incoming via {channel}",
    confirmedTag: "Confirmed",
    pendingTag: "Pending",
    bookingConfirmed: "Booking confirmed",
    pendingConfirmation: "Pending confirmation",
    receivedConfirmation: "received the booking confirmation",
    awaitingConfirmationAction: "is pending confirmation",
    propertyConfirmed: "The property confirmed the booking",
    awaitingConfirmationDesc: "Awaiting confirmation",
    sentTag: "Sent",
    notSentTag: "Not sent",
    checkinInvitationTitle: "Check-in invitation",
    receivedCheckinInvite: "received the check-in invitation",
    notReceivedCheckinInvite: "has not yet received the check-in invitation",
    checkinLinkSent: "Check-in link sent to the guest",
    inviteNotSentYet: "The invitation has not been sent yet",
    completedTag: "Completed",
    checkinOnline: "Online check-in",
    didCheckinOnline: "completed the online check-in",
    notYetCheckinOnline: "has not yet completed the online check-in",
    guestsRegistered: "{count} guest(s) registered",
    guestNotCompletedCheckin: "The guest has not yet completed the check-in",
    sentTagPlural: "Sent",
    accessCodes: "Access codes",
    receivedAccessCodes: "received the access codes",
    notReceivedAccessCodes: "has not yet received the access codes",
    accessKeysSent: "Access keys sent to the guest",
    pendingSendAccess: "Pending sending the access",
    finishedTag: "Finished",
    plannedTag: "Planned",
    guestCheckout: "Guest check-out",
    finishedStay: "finished their stay",
    plannedCheckout: "has check-out scheduled",
    stayFinished: "The stay has finished",
    autoCheckoutScheduled: "Automatic check-out scheduled",
    theGuest: "The guest",
    theTeam: "The team",
    theChannel: "The channel",
    theSystem: "The system",
    calledFromNumber: "called from the number {phone}",

    filterAll: "All",
    filterWhatsapp: "WhatsApp",
    filterCalls: "Calls",
    filterCheckin: "Check-in",
    filterAccess: "Access",
    filterBooking: "Booking",

    error: "Error",
    requestApprovedMsg: "Request approved. The booking is confirmed.",
    requestApprovedTitle: "✓ Approved",
    couldNotApprove: "Could not approve.",
    confirmRejectRequestMsg: "Are you sure you want to reject this request? It cannot be undone.",
    rejectRequestHeader: "Reject request",
    yesReject: "Yes, reject",
    requestRejectedMsg: "Request rejected.",
    rejectedTitle: "Rejected",
    couldNotReject: "Could not reject.",
    couldNotLoadOptions: "The options could not be loaded; the total will be marked.",
    noticeTitle: "Notice",
    depositMarkedPaid: "Deposit marked as paid. Booking confirmed with an outstanding balance.",
    fullMarkedPaid: "Booking marked as paid in full and confirmed.",
    paymentConfirmedTitle: "Payment confirmed",
    couldNotMarkPaid: "Could not mark as paid.",
    tempReservationExpired: "The temporary booking was expired and released availability.",
    reservationExpiredTitle: "Booking expired",
    couldNotMarkExpired: "Could not mark as expired.",
    extensionMarkedPaid: "The extension was marked as paid and confirmed.",
    extensionConfirmedTitle: "Extension confirmed",
    couldNotConfirmExtension: "The extension could not be confirmed.",
    extensionCancelled: "The extension was canceled and availability was released.",
    extensionRejectedTitle: "Extension rejected",
    couldNotRejectExtension: "The extension could not be rejected.",
    chargeMarkedPaid: "The charge was marked as paid.",
    chargeRegisteredTitle: "Payment recorded",
    couldNotMarkChargePaid: "The charge could not be marked as paid.",
    chargeRejected: "The charge was rejected and removed from the booking.",
    chargeRejectedTitle: "Charge rejected",
    couldNotRejectCharge: "The charge could not be rejected.",
    approvedState: "Approved",
    rejectedState: "Rejected",
    paidState: "Paid",
    pendingYourResponse: "Pending your response",
    enterValidAmount: "Enter a valid amount (0 = no charge).",
    amountTitle: "Amount",
    approvedPaymentLinkSent: "Approved. The payment link was sent to the guest (WhatsApp + email).",
    serviceApprovedTitle: "Service approved",
    approvedPayOnArrival: "Approved. The guest will pay on arrival (no gateway connected).",
    approvedGuestNotified: "Approved. The guest was notified.",
    couldNotApproveRequest: "The request could not be approved.",
    requestRejectedNotified: "Request rejected. The guest was notified.",
    serviceRejectedTitle: "Service rejected",
    couldNotRejectRequest: "The request could not be rejected.",
    resendAccessLinkMsg: "Do you want to resend the access link through the available channels?",
    sendAccessLinkMsg: "Do you want to send the access link through the available channels?",
    resendPinMsg:
      "Do you want to resend the access code through the available channels? A new PIN will be generated.",
    sendPinMsg: "Do you want to generate and send the access code through the available channels?",
    sendDigitalAccessHeader: "Send Digital Access",
    sendPinHeader: "Send Access PIN",
    send: "Send",
    accessLinkSent: "Access link sent to the guest",
    accessSentTitle: "Access Sent",
    successSummary: "Success",
    digitalAccessSentDetail: "Digital access was sent for {count} device(s)",
    ttlockCodesGenerated: "{count} TTLock codes were generated and processed for the booking.",
    accessCodeResent: "Access code resent: {code}",
    accessCodeGeneratedSent: "Access code generated and sent: {code}",
    pinSentTitle: "PIN Sent",
    pinProcessedDetail: "The PIN was processed for {count} lock(s)",
    pinProcessedBlebox: "and {count} electronic door(s)",
    couldNotSendAccessCode: "The access code could not be sent",
    codeCopied: "Code copied to the clipboard",
    mainGate: "Main gate",
    accommodation: "Property",
    doorLabel: "Property door",
    validUntil: "Valid until: {date}",
    earlyAccessLinkMsg:
      "This will activate the access link immediately (before the normal check-in time).",
    earlyAccessPinMsg: "This will activate the PIN immediately (before the normal check-in time).",
    earlyAccessHeader: "Early access",
    activate: "Activate",
    earlyAccessActivated: "Early access activated",
    okSummary: "OK",
    earlyAccessActivatedDetail: "Early access was activated",
    couldNotActivateEarlyAccess: "Early access could not be activated",
    cancelReservationMsg:
      "The booking will be canceled entirely. If it occupies several rooms (even of different types), they will all be canceled and released. This action cannot be undone.",
    goBack: "Back",
    resolveOverbookingMsg:
      "It will be checked that there is no longer a conflict with another booking. If it is free, the booking will become confirmed and its dates will remain blocked on the OTAs.",
    confirmOverbookingHeader: "Confirm booking in overbooking",
    reservationConfirmed: "Booking confirmed.",
    couldNotConfirmReservation: "The booking could not be confirmed.",
    reservationCancelledFreed: "Booking canceled. {count} rooms were released.",
    otaLangPrompt:
      "This OTA booking has no phone number. Indicate the message language to send the check-in through the OTA chat: es, en, fr, pt, ar, it, de",
    inviteProcessedEmailOta: "Invitation processed. Also sent by email and OTA chat.",
    inviteProcessedOta: "Invitation processed. Also sent by OTA chat.",
    inviteProcessedEmail: "Invitation processed. Also sent by email.",
    couldNotSendCheckinInvite: "The check-in invitation could not be sent",
    couldNotLoadConversations: "The conversations could not be loaded",
    reservationUpdatedShort: "Booking updated",
    couldNotUpdateReservation: "The booking could not be updated",
    codeEmpty: "The code cannot be empty",
    attentionTitle: "Attention",
    accessCodeProcessed: "Access code processed successfully",
    sentCheckTitle: "Sent ✓",
    accessCodeSendProcessed: "The access code delivery was processed.",
    couldNotSendCode: "The code could not be sent",
    chatOta: "OTA chat",
    emailChannel: "email",
    channelsUsed: "Channels used: {channels}.",
  },

  // ── HotelReservationModal.vue ─────────────────────────────────────────────
  telefonoDelHuesped: {
    noValido: "This phone number doesn't look valid for {pais}. If the guest is from another country, change the flag. Press save again to keep it anyway.",
  },
  hotelResModal: {
    otaBanner:
      "OTA booking: you cannot change <strong>dates</strong>, <strong>type</strong> or <strong>number of rooms</strong> from WA Checkin. You must do it from the OTA (Booking, Airbnb, etc.).",
    otaLock: "OTA booking: dates, type and quantity can only be changed from the OTA.",
    close: "Close",
    placeholderEmail: "email@example.com",
    roomAbbr: "Room",
    fromCalendar: "from the calendar",
    noMatches: "No matches",
    undo: "Undo",
    removeRoom: "Remove room",
    willBeRemovedOnSave: "It will be removed when you save the changes.",
    checkingAvailability: "Checking availability…",
    availableCount: "{count} available | {count} available",
    notEnoughAvail: "Not enough availability",
    freeCount: "{count} free | {count} free",
    total: "total",
    nightsCount: "{count} night | {count} nights",
    resendConfirmationTitle: "Resend confirmation message",
    resendConfirmationSub: "Send the confirmation template to the guest again.",
    resendConfirmationNote:
      "When you modify the booking, the <strong>confirmation template</strong> for this booking will be resent.",
    room: "Room",

    noEnoughUnitsFree: "Not enough availability. Free units: {units}.",
    closedPeriodManual: "The dates include days closed by the owner.",
    noAvailForDates: "No availability for those dates.",
    selectRoomType: "Select a room type.",
    selectValidDates: "Select valid dates.",
    enterGuestName: "Enter the guest's name.",
    invalidEmail: "The email is not valid.",
    enterValidPhone: "Enter a valid phone number.",
    noAvailCreateModify: "No availability to create/modify with those dates.",
    aRoom: "a room",
    notEnoughAvailIn: "Not enough availability in: {names}.",
    missingOnCreate: "onCreateReservation is missing in the parent component.",
    aRoomType: "a room type",
    notEnoughAvailInType: `Not enough availability in "{name}".`,
    sameHotelOnly: "A booking can’t mix rooms from two hotels. Remove the ones that aren’t from this hotel.",
    otherHotelLinesDropped: "Rooms from the previous hotel were removed: a booking belongs to a single hotel.",
    partiallyCreated: "{ok} of {total} rooms were created and the next one failed. Check the booking before trying again.",
    reservationIdNotFound: "Booking ID not found.",
    cannotRemoveAll: "You cannot remove all the rooms. To do that, cancel the entire booking.",
    thisRoom: "this room",
    confirmRemoval:
      "You are about to REMOVE from the booking: {names}. Those rooms are released and stop being billed. Continue and save?",
    couldNotAdd: "Could not add {name}.",
    couldNotUpdate: `Could not update "{name}".`,
    couldNotRemove: `Could not remove "{name}".`,
    couldNotRemovePrimary: "The main room could not be removed.",
    reservationUpdated: "Booking updated successfully",
    updatedPartially: "Only part of it was saved: check the rooms on this booking.",
    couldNotUpdateReservation: "The booking could not be updated.",
  },
};
